import request from '@/utils/request'

let FullreduceApi = {
    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/plus.fullreduce.Fullreduce/index', data, errorback);
    },
    /*添加*/
    add(data, errorback) {
        return request._post('/shop/plus.fullreduce.Fullreduce/add', data, errorback);
    },
    /*修改*/
    edit(data, errorback) {
        return request._post('/shop/plus.fullreduce.Fullreduce/edit', data, errorback);
    },
    /*删除*/
    del(data, errorback) {
        return request._post('/shop/plus.fullreduce.Fullreduce/delete', data, errorback);
    },
    /*列表*/
    product(data, errorback) {
        return request._post('/shop/plus.fullreduce.Fullreduce/product', data, errorback);
    },
    editProduct(data, errorback) {
        return request._post('/shop/plus.fullreduce.Fullreduce/editProduct', data, errorback);
    },
}

export default FullreduceApi;



// WEBPACK FOOTER //
// ./src/api/fullreduce.js